
export const getDemoUserList=async(dynamoDBClient)=>{
    try {
         const params={
            TableName:"ActivityTracking",
        }

        const data=await dynamoDBClient.scan(params).promise()
        return data.Items
    } catch (error) {
        throw new Error(error)
    }
}
